import { useEffect, useState } from 'react';
import { beautify } from '../../../../../helpers/str';
import NodeGeneral from './NodeGeneral';
import NodeLayout from './NodeLayout';
import NodePermissions from './NodePermissions';
import NodeEdges from './NodeEdges';
import NodeApiConfig from './NodeApiConfig';
import NodeTaskConfig from './NodeTaskConfig';

const NodeSettings = ({ node, onClose }) => {
    const [tabs, setTabs] = useState([]);
    const [tab, setTab] = useState('');
    useEffect(() => {
        let newTabs = ['general'];
        if (node?.type === 'web_form') {
            newTabs.push('layout');
        }
        if (node?.type === 'api_request') {
            newTabs.push('api_config');
        }
        if (node?.type === 'task' && node?.config?.name === 'send_email') {
            newTabs.push('email_config');
        }
        if (node?.type === 'task' && node?.config?.name === 'generate_pdf') {
            newTabs.push('pdf_config');
        }
        newTabs = [...newTabs, 'permissions', 'edges'];
        setTabs(newTabs);
        setTab(['permissions', 'edges'].includes(newTabs[1]) ? newTabs[0] : newTabs[1]);
    }, [node]);
    return (
        <div className={`card panel`}>
            <div
                onClick={onClose}
                className='cursor-pointer position-absolute w-40px h-40px bg-white shadow shadow-sm top-50 rounded-circle text-center'
                style={{ marginTop: '-20px', marginLeft: '-20px', lineHeight: '40px' }}>
                <i className='bi-chevron-right fs-3'></i>
            </div>
            <div className='card-body p-0'>
                <ul className='navpills m-5 p-0'>
                    {tabs.map((row) => {
                        return (
                            <li
                                key={row}
                                className='navpills__item'
                                onClick={() => setTab(row)}>
                                <span
                                    className={`fs-9 navpills__item__link ${
                                        tab === row ? 'navpills__item__link-active' : ''
                                    }`}>
                                    {beautify(row)}
                                </span>
                            </li>
                        );
                    })}
                </ul>
                <div>
                    {tab === 'general' && <NodeGeneral config={node}></NodeGeneral>}
                    {tab === 'api_config' && <NodeApiConfig config={node?.config}></NodeApiConfig>}
                    {tab === 'layout' && <NodeLayout config={node?.config}></NodeLayout>}
                    {['email_config', 'pdf_config'].includes(tab) && (
                        <NodeTaskConfig config={node?.config}></NodeTaskConfig>
                    )}
                    {tab === 'permissions' && (
                        <NodePermissions config={node?.permissions}></NodePermissions>
                    )}
                    {tab === 'edges' && <NodeEdges config={node?.edges}></NodeEdges>}
                </div>
            </div>
        </div>
    );
};
export default NodeSettings;
